// src/components/seo/ServiceSchemas.tsx
export const CultureLabSchema = () => (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{
      __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Service",
        name: "Culture Lab Analysis",
        description:
          "Free cultural transformation analysis for corporate spaces, property development, and hospitality venues",
        provider: {
          "@type": "Organization",
          name: "The Content Group",
        },
        serviceType: "Cultural Space Transformation Analysis",
        audience: {
          "@type": "BusinessAudience",
          audienceType:
            "Property Developers, Hospitality Venues, Retail Spaces",
        },
        offers: {
          "@type": "Offer",
          price: "0",
          priceCurrency: "GBP",
          description:
            "Free Culture Lab analysis with personalized recommendations",
        },
      }),
    }}
  />
);

export const MagDropsSchema = () => (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{
      __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Service",
        name: "MagDrops Custom Magazine Production",
        description:
          "Custom magazine production and editorial content in 4-6 weeks",
        provider: {
          "@type": "Organization",
          name: "The Content Group",
          brand: "Yolklore",
        },
        serviceType: "Magazine Production Service",
        offers: [
          {
            "@type": "Offer",
            name: "Quick Run",
            price: "2000",
            priceCurrency: "GBP",
            description: "Magazine production in 4 weeks",
          },
          {
            "@type": "Offer",
            name: "Editor Run",
            price: "6000",
            priceCurrency: "GBP",
            description: "Premium magazine with editorial content in 6 weeks",
          },
        ],
      }),
    }}
  />
);

export const FamilySpacesSchema = () => (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{
      __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Service",
        name: "Family Spaces Transformation",
        description: "Family-centric placemaking and marketing services",
        provider: {
          "@type": "Organization",
          name: "The Content Group",
          brand: ["Honey House", "Oya Labs"],
        },
        serviceType: "Family Placemaking Service",
        audience: {
          "@type": "BusinessAudience",
          audienceType: "Property Developers, Family Venues, Community Spaces",
        },
      }),
    }}
  />
);
